<template>
  <div class="container">
    <h1>Create a Work Order for FMTSS</h1>
    <div v-if="showMessage" class="alert " v-bind:class="messageClass">
      {{this.message}}
    </div>
    <div class="row">
      <div class="col-md-4">
        <form>
          <div class="form-group">
            <label>Customer Name</label>
            <input type="text" class="form-control" v-model="form.customerName">
          </div>
        </form>
      </div>
      <div class="col-md-4">
        <form>
          <div class="form-group">
            <label>Customer Email</label>
            <input type="email"  class="form-control" v-model="form.customerEmail">
          </div>
        </form>
      </div>
      <div class="col-md-4">
        <form>
          <div class="form-group">
            <label for="frmPhoneNumA">Customer Phone Number</label>
            <input type="tel" name="phone" id="frmPhoneNumA" autocomplete="tel" class="form-control" v-model="form.customerPhoneNumber">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form>
          <div class="form-group">
            <label for="frmAddress">Address</label>
            <input name="address" required id="frmAddress" autocomplete="address" type="text" class="form-control" v-model="form.address">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Service Requested By</label>
            <input type="text" class="form-control" v-model="form.serviceRequestedBy">
          </div>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <div for="frmNameA" class="form-group">
            <label id="frmNameA">Contact Name</label>
            <input autocomplete="name" type="text" class="form-control" v-model="form.contactName">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Machine</label>
            <input type="text" class="form-control" v-model="form.machine">
          </div>
        </form>
      </div>
      <div class="col-md-3">
        <form>
          <div class="form-group">
            <label>Machine Number</label>
            <input type="text" class="form-control" v-model="form.machineNumber">
          </div>
        </form>
      </div>
      <div class="col-md-3">
        <form>
          <div class="form-group">
            <label>Serial Number</label>
            <input type="text" class="form-control" v-model="form.serialNumber">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form>
          <div class="form-group">
            <label>Description of Problem / Project</label>
            <textarea class="form-control" v-model="form.description"></textarea>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="text-center">
        <button class="btn btn-primary" @click="createWorkorder">Create Work Order</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
const firebase = require('firebase/app');

require('firebase/database');

  export default {
    data() {
      return {
        showMessage: false,
        messageClass: '',
        form: {
          date: new Date(),
          invoiceNumber: '',
          callTakenBy: '',
          requestDate: '',
          customerName: '',
          customerPhoneNumber: '',
          address: '',
          serviceRequestBy: '',
          contactName: '',
          machine: '',
          machineNumber: '',
          serialNumber: '',
          description: '',
          createdOn: new Date().toISOString()
        },
        show: true
      }
    },
    methods: {
      email(id){
        firebase.firestore().collection('mail').add({
          to: 'contact@flmachinetool.com',
          message: {
            subject: `New Work Order Created ${id}`,
            text: 'View the work order from the link below',
            html: `<a href="https://fmtss-workorder.firebaseapp.com/workorder/${id}">View Here</a>`,
          }
        })
        .then(() => console.log('Queued email for delivery!'))
        .catch(err => {
          console.log(err);
        });
        firebase.firestore().collection('mail').add({
          to: 'floridamtss@gmail.com',
          message: {
            subject: `New Work Order Created ${id}`,
            text: 'View the work order from the link below',
            html: `<a href="https://fmtss-workorder.firebaseapp.com/workorder/${id}">View Here</a>`,
          }
        })
        .then(() => console.log('Queued email for delivery for Floridamtss!'))
        .catch(err => {
          console.log(err);
        });
      },
      resetForm() {
        this.form = {
          date: new Date(),
          invoiceNumber: '',
          callTakenBy: '',
          requestDate: '',
          customerName: '',
          customerPhoneNumber: '',
          address: '',
          serviceRequestBy: '',
          contactName: '',
          machine: '',
          machineNumber: '',
          serialNumber: '',
          description: '',
          createdOn: new Date().toISOString()
        }
      },
      async generateId(){
        return new Promise((resolve) => {
          const workordersDB = firebase.firestore().collection('workorders');

          workordersDB.get().then(snap => {
            console.log('In Promise')
            resolve(`FMTSS-${1000 + snap.size}`);
          });
        })
      },
      async createWorkorder() {
        const workordersDB = firebase.firestore().collection('workorders');
        this.form.id = await this.generateId();
        this.form.date = moment(this.form.date).toISOString();
        this.form.requestDate = moment(this.form.requestDate).toISOString();
        workordersDB.doc(this.form.id).set(this.form).then(ref => {
          console.log(ref)
          this.showMessage = true;
          this.message = 'Your work order has been submitted! Florida Machine Tool Supply and Service should contact you soon.'
          this.messageClass = 'alert-success';
          this.email(this.form.id);
          this.resetForm();
          setTimeout(() => {
            this.showMessage = false;
            this.messageClass = '';
          }, 5000);
        }).catch(err => {
          this.showMessage = true;
          this.message = 'Something went wrong please try again or call FMTSS directly';
          this.messageClass = 'alert-danger';
          setTimeout(() => {
            this.showMessage = false;
            this.messageClass = '';
          }, 5000);
          console.log(err)
        })
      }
    }
  }
</script>